<template>
  <div class="filters-container">
    <!-- Header -->
    <div class="table-header">
      <div class="header-left">
        <div class="icon-wrapper">
          <v-icon color="#023449" size="22">mdi-table</v-icon>
        </div>
        <div>
          <h3 class="table-title">Análise de Divergências por Filial</h3>
          <p class="table-subtitle">
            {{ totalFiliais }} filia{{ totalFiliais !== 1 ? 'is' : 'l' }} •
            {{ totalLancamentos }} lançamentos
          </p>
        </div>
      </div>
      <div class="table-controls">
        <v-btn
            v-if="false"
            small
            outlined
            color="#023449"
            @click="toggleFilters"
            class="action-btn"
        >
          <v-icon left small>{{ showFilters ? 'mdi-filter-off' : 'mdi-filter' }}</v-icon>
          {{ showFilters ? 'Ocultar Filtros' : 'Filtros' }}
          <v-badge
              v-if="activeFiltersCount > 0"
              :content="activeFiltersCount"
              color="#dc2626"
              overlap
              class="ml-2"
          >
          </v-badge>
        </v-btn>
        <v-btn
            small
            outlined
            color="#023449"
            @click="toggleFullscreen"
            class="action-btn"
        >
          <v-icon left small>{{ isFullscreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen' }}</v-icon>
          {{ isFullscreen ? 'Sair Tela Cheia' : 'Tela Cheia' }}
        </v-btn>
        <v-btn
            small
            outlined
            color="#023449"
            @click="expandAll"
            class="action-btn"
            :disabled="totalLancamentos>500"
        >
          <v-icon left small>mdi-arrow-expand-vertical</v-icon>
          Expandir Todos
        </v-btn>
        <v-btn
            small
            outlined
            color="#023449"
            @click="collapseAll"
            class="action-btn"
        >
          <v-icon left small>mdi-arrow-collapse-vertical</v-icon>
          Recolher Todos
        </v-btn>
      </div>
    </div>

    <!-- Filtros Expansíveis -->
    <v-expand-transition>
      <div v-show="showFilters" class="filters-panel">
        <v-card elevation="0" class="filters-card">
          <v-card-text class="pa-4">
            <div class="filters-grid">
              <!-- Filtro Tipo -->
              <div class="filter-group">
                <label class="filter-label">
                  <v-icon small color="#023449" class="mr-1">mdi-shape</v-icon>
                  Tipo
                </label>
                <v-select
                    v-model="localFilters.tipo"
                    :items="tipoOptions"
                    placeholder="Selecione o tipo"
                    outlined
                    dense
                    hide-details
                    clearable
                    class="filter-select"
                    @change="emitFilters"
                >
                  <template v-slot:prepend-inner>
                    <v-icon small color="#64748b">mdi-shape-outline</v-icon>
                  </template>
                </v-select>
              </div>

              <!-- Filtro Status -->
              <div class="filter-group">
                <label class="filter-label">
                  <v-icon small color="#023449" class="mr-1">mdi-check-circle</v-icon>
                  Status
                </label>
                <v-select
                    v-model="localFilters.status"
                    :items="statusOptions"
                    placeholder="Selecione o status"
                    outlined
                    dense
                    hide-details
                    clearable
                    class="filter-select"
                    @change="emitFilters"
                >
                  <template v-slot:prepend-inner>
                    <v-icon small color="#64748b">mdi-check-circle-outline</v-icon>
                  </template>
                  <template v-slot:selection="{ item }">
                    <v-chip
                        x-small
                        :color="getStatusChipColor(item)"
                        :text-color="getStatusChipTextColor(item)"
                        class="mr-1"
                    >
                      {{ item }}
                    </v-chip>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-chip
                        x-small
                        :color="getStatusChipColor(item)"
                        :text-color="getStatusChipTextColor(item)"
                        class="mr-2"
                    >
                      {{ item }}
                    </v-chip>
                    <span>{{ item }}</span>
                  </template>
                </v-select>
              </div>
            </div>

            <!-- Ações dos Filtros -->
            <div class="filters-actions">
              <v-btn
                  small
                  text
                  color="#dc2626"
                  @click="clearFilters"
                  :disabled="activeFiltersCount === 0"
                  class="clear-btn"
              >
                <v-icon left small>mdi-filter-off</v-icon>
                Limpar Filtros
              </v-btn>
              <div class="filters-info">
                <v-chip
                    v-if="activeFiltersCount > 0"
                    x-small
                    color="#dbeafe"
                    text-color="#1e40af"
                    class="font-weight-bold"
                >
                  {{ activeFiltersCount }} filtro{{ activeFiltersCount !== 1 ? 's' : '' }} ativo{{ activeFiltersCount !== 1 ? 's' : '' }}
                </v-chip>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
export default {
  name: 'FiliaisViewFilters',
  props: {
    totalFiliais: {
      type: Number,
      default: 0
    },
    totalLancamentos: {
      type: Number,
      default: 0
    },
    isFullscreen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showFilters: false,
      localFilters: {
        tipo: null,
        status: null
      },
      tipoOptions: [
        'ROTATIVO',
        'AVARIA',
        'BALANCO'
      ],
      statusOptions: [
        'FINALIZADO',
        'Em aberto'
      ]
    };
  },
  computed: {
    activeFiltersCount() {
      let count = 0;
      if (this.localFilters.tipo) count++;
      if (this.localFilters.status) count++;
      return count;
    }
  },
  methods: {
    toggleFilters() {
      this.showFilters = !this.showFilters;
    },
    toggleFullscreen() {
      this.$emit('toggle-fullscreen');
    },
    expandAll() {
      this.$emit('expand-all');
    },
    collapseAll() {
      this.$emit('collapse-all');
    },
    emitFilters() {
      this.$emit('filters-changed', { ...this.localFilters });
    },
    clearFilters() {
      this.localFilters = {
        tipo: null,
        status: null
      };
      this.emitFilters();
    },
    getStatusChipColor(status) {
      const colors = {
        'FINALIZADO': '#e8f5e9',
        'PENDENTE': '#fff3e0'
      };
      return colors[status] || '#f3f4f6';
    },
    getStatusChipTextColor(status) {
      const colors = {
        'FINALIZADO': '#2e7d32',
        'Em aberto': '#e65100'
      };
      return colors[status] || '#374151';
    }
  }
};
</script>

<style scoped>
.filters-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0;
}

/* Header */
.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  background: #ffffff;
  padding: 20px 24px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(2, 52, 73, 0.04);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.icon-wrapper {
  background: linear-gradient(135deg, rgba(2, 52, 73, 0.08) 0%, rgba(2, 52, 73, 0.04) 100%);
  border-radius: 10px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.table-title {
  margin: 0;
  color: #023449;
  font-size: 1.125rem;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.table-subtitle {
  margin: 4px 0 0 0;
  color: #64748b;
  font-size: 0.813rem;
  font-weight: 500;
}

.table-controls {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}

.action-btn {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;
}

/* Filtros Panel */
.filters-panel {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-top: none;
  border-radius: 0 0 12px 12px;
  overflow: hidden;
}

.filters-card {
  background: transparent !important;
}

.filters-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filter-label {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  font-weight: 600;
  color: #023449;
  margin-bottom: 4px;
}

.filter-select >>> .v-input__control {
  min-height: 40px !important;
}

.filter-select >>> .v-input__slot {
  min-height: 40px !important;
  background: #ffffff !important;
}

.filter-select >>> fieldset {
  border-color: #cbd5e1 !important;
  border-width: 1.5px !important;
}

.filter-select >>> .v-input__slot:hover fieldset {
  border-color: #023449 !important;
}

.filter-select >>> .v-select__selections {
  padding: 0 8px;
}

.filter-select >>> .v-input__icon--prepend-inner {
  margin-right: 8px;
}

/* Ações dos Filtros */
.filters-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 16px;
  border-top: 1px solid #e2e8f0;
  flex-wrap: wrap;
  gap: 12px;
}

.clear-btn {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;
}

.filters-info {
  display: flex;
  gap: 8px;
  align-items: center;
}

/* Badge no botão de filtros */
.action-btn >>> .v-badge__badge {
  font-size: 0.625rem;
  height: 18px;
  min-width: 18px;
  padding: 0 4px;
  font-weight: 700;
}

/* Responsive */
@media (max-width: 1024px) {
  .table-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .table-controls {
    width: 100%;
    flex-direction: column;
  }

  .action-btn {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .header-left {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .filters-grid {
    grid-template-columns: 1fr;
  }

  .filters-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .clear-btn {
    width: 100%;
  }
}

@media (max-width: 600px) {
  .table-header {
    padding: 16px;
  }

  .icon-wrapper {
    padding: 8px;
  }

  .table-title {
    font-size: 1rem;
  }

  .table-subtitle {
    font-size: 0.75rem;
  }
}

/* Animations */
.v-expand-transition-enter-active,
.v-expand-transition-leave-active {
  transition: all 0.3s ease;
}

.v-expand-transition-enter,
.v-expand-transition-leave-to {
  opacity: 0;
}
</style>